<script setup lang="ts">
const containerRef = useTemplateRef("containerRef")
const imageRef = useTemplateRef("imageRef")
const gptRef1 = useTemplateRef("gptRef1")
const gptRef2 = useTemplateRef("gptRef2")
</script>

<template>
	<div class="grid w-full place-items-center">
		<div
			ref="containerRef"
			class="relative w-full flex items-center justify-center overflow-hidden md:max-w-[500px]">
			<div class="size-full flex flex-col items-stretch justify-between gap-10">
				<div class="flex items-center justify-between">
					<AnimatedBeamCircle ref="imageRef">
						<NuxtImg
							src="/website/big-logo.png"
							format="webp"
							fit="inside"
							width="153"
							height="90" />
					</AnimatedBeamCircle>

					<div class="flex flex-col items-center justify-between gap-12">
						<AnimatedBeamCircle ref="gptRef1">
							<div class="flex flex-col items-center gap-1">
								<Icon
									name="i-arcticons:openai-chatgpt"
									class="size-22 text-primary" />

								<h3 class="text-primary font-bold">
									GPT 4o
								</h3>
							</div>
						</AnimatedBeamCircle>

						<AnimatedBeamCircle ref="gptRef2">
							<div class="flex flex-col items-center gap-1">
								<Icon
									name="i-arcticons:openai-chatgpt"
									class="size-22 text-foreground" />

								<h3 class="font-bold">
									GPT 4o mini
								</h3>
							</div>
						</AnimatedBeamCircle>
					</div>
				</div>
			</div>

			<ClientOnly>
				<AnimatedBeam
					gradient-start-color="var(--primary)"
					:duration="3"
					:container-ref="containerRef"
					:from-ref="imageRef"
					:to-ref="gptRef1" />

				<AnimatedBeam
					gradient-start-color="var(--primary)"
					:duration="3"
					:container-ref="containerRef"
					:from-ref="imageRef"
					:to-ref="gptRef2" />
			</ClientOnly>
		</div>
	</div>
</template>
